// Func = limiting Scope for this file
(function(){ 
	
	let hash_id = location.hash.substr(1);
	console.log(hash_id);
	if(document.getElementById(hash_id)){
		// const element = document.getElementById(hash_id);
		// console.log(element);
		// element.scrollIntoView({ behavior: 'smooth', block: 'start' });
		animateTo(hash_id);
	} 

	function resizeWindow(){

	}

	let scrollpos = window.scrollY;
	let header = document.getElementById("header");

	function add_class_on_scroll() {
	    header.classList.add("scroll");
	}

	function remove_class_on_scroll() {
	    header.classList.remove("scroll");
	}

	function scrollDown(){
		let top = $(document).scrollTop();
		if (top > 10) {
			add_class_on_scroll();
		} else {
			remove_class_on_scroll();
		}
	}

	function animateTo(target){
		var gotoTarget = document.getElementById(target).offsetTop + 350
		var from     = window.pageYOffset
		var to       = gotoTarget
		var duration = 1300; 
		var start = new Date().getTime()

		//time interval
		var timer = setInterval(function() {
			var time = new Date().getTime() - start

			if(from <= to ){
				var y = easeInOutQuart(time, from, to - from, duration)
			} else {
				
				var y = easeInOutQuart(time, from, -(from - to), duration)
			}
			window.scrollTo(0, y)
			if (time >= duration) clearInterval(timer)

		}, 1000 / 60);

		window.scrollTo(0, from)

	}

	//ease movement
	function easeInOutQuart(t, b, c, d) {
		if ((t /= d / 2) < 1) return c / 2 * t * t * t * t + b;
		return -c / 2 * ((t -= 2) * t * t * t - 2) + b;
	}

	function addAdaMapLink ( class_name = '', label = 'View ADA MAP', href = '/ada-map', container= 'myMap') {
		let block_to_insert;
		 
		block_to_insert = document.createElement( 'div' );
		block_to_insert.setAttribute('class', 'note');
		block_to_insert.innerHTML = '<a class="btn '+class_name+'" href="'+href+'">'+label+'</a>';

		if(document.getElementById(container)){
			document.getElementById(container).appendChild( block_to_insert );
		}
	}


	$(document).ready(function () {

		$(".fancybox").fancybox();

		//show the uvp with animation delay
		if (document.querySelector('.uvp-subtitle')){
			setTimeout( ()=> document.querySelector('.uvp-subtitle').classList.add('fade-in'),0);
			setTimeout( ()=> document.querySelector('.uvp').classList.add('fade-in'),0);
		}
		// setTimeout( ()=> document.querySelector('.uvp-subtitle.postitle').classList.add('fade-in'),0);

		if (document.querySelector('main')){
			setTimeout( ()=> document.querySelector('main').classList.add('fade'),0);
		}
		if (document.querySelector('footer')){
			setTimeout( ()=> document.querySelector('footer').classList.add('fade'),0);
		}
		//Call function with browser is resized.
		$(window).resize(function (event) {
			resizeWindow();
		});
		resizeWindow();

		//Acts when scroll down page.
		$(window).scroll(function (event) {
			scrollDown();
		});

		
		/*MOBILE MENU NAV
		****************************************************************/
		
		//Menu Burger Navigation Mobile
		$('#js-mobile-menu-btn').click(function(event) {
			$('html').addClass('hide-overflow');
			$('.navigation').addClass('open');
			$('.navigation').stop().animate({left:'0px'},{duration:300});
			if($('.navigation ul li a').hasClass('.item-open')){
				$(".item-open").get(0).scrollIntoView(false);
			}
		});
		$('.close-menu').click(function(event) {
			event.preventDefault();
			$('html').removeClass('hide-overflow');
			$('.navigation').stop().animate({left:'100%'},{queue:false,duration:300});
			$('.navigation').removeClass('open');
		});

		//Menu Burger Navigation Web
		$('#js-menu-btn').click(function(event) {
			$('.navigation-web').addClass('open');
			$('#menu-open').fadeToggle();
			$('#menu-close').fadeToggle();
		});
		$('#menu-close').click(function(event) {
			event.preventDefault();
			$('.navigation-web').removeClass('open');
			$('#menu-open').fadeToggle();
			$('#menu-close').fadeToggle();
		});

		// Main Nav Dropdown
		$("#primary-nav li").hover(function(){
			$(this).addClass("hover");
			$('ul.submenu',this).fadeIn(200);
		}, function(){
			$(this).removeClass("hover");
			$('ul.submenu',this).fadeOut(200);
		});

		// Main Menu check if the li have submenu
		$(".navigation.overlay ul li .sub-sub-menu").each(function(){
			$(this).parent().addClass("isparent-submenu");
		});

		// Nav submenu mobile
		$('.isparent-submenu a').click(function(event){
			if($(this).parent().hasClass("isparent-submenu") ){
				event.preventDefault();
				$(this).siblings('.sub-sub-menu').fadeToggle( "slow", "linear" );
			}
		});

		//Check in and check out datepicker for booking engine
		$( "#CheckIn" ).datepicker({
			//showOn: "both",
			//buttonImage: SITE_FILES+"images/img-calendar-gray.png",
			//buttonImageOnly: true,
			changeMonth: true,
			numberOfMonths: 1,
			minDate: 0,
			onSelect: function( selectedDate ) {
				let getDate = $(this).datepicker('getDate');
				let newDate = new Date(getDate.getTime());
				newDate.setDate(newDate.getDate() + 3);
				$( "#CheckOut" ).datepicker( "setDate", newDate );
				$( "#CheckOut" ).datepicker( "option", "minDate", selectedDate );
			}
		});
		$( "#CheckOut" ).datepicker({
			//showOn: "both",
			//buttonImage: SITE_FILES+"images/img-calendar-gray.png",
			//buttonImageOnly: true,
			changeMonth: true,
			numberOfMonths: 1,
			onSelect: function( selectedDate ) {
				//$( "#CheckIn" ).datepicker( "option", "maxDate", selectedDate );
			}
		});

		//Check in and check out datepicker for booking engine
		$( "#CheckIn2" ).datepicker({
			//showOn: "both",
			//buttonImage: SITE_FILES+"images/img-calendar-gray.png",
			//buttonImageOnly: true,
			changeMonth: true,
			numberOfMonths: 1,
			minDate: 0,
			onSelect: function( selectedDate ) {
				let getDate = $(this).datepicker('getDate');
				let newDate = new Date(getDate.getTime());
				newDate.setDate(newDate.getDate() + 3);
				$( "#CheckOut2" ).datepicker( "setDate", newDate );
				$( "#CheckOut2" ).datepicker( "option", "minDate", selectedDate );
			}
		});
		$( "#CheckOut2" ).datepicker({
			//showOn: "both",
			//buttonImage: SITE_FILES+"images/img-calendar-gray.png",
			//buttonImageOnly: true,
			changeMonth: true,
			numberOfMonths: 1,
			onSelect: function( selectedDate ) {
				//$( "#CheckIn" ).datepicker( "option", "maxDate", selectedDate );
			}
		});


		//Check in and check out datepicker for booking engine
		$( "#pre-CheckIn" ).datepicker({
			//showOn: "both",
			//buttonImage: SITE_FILES+"images/img-calendar-gray.png",
			//buttonImageOnly: true,
			changeMonth: true,
			numberOfMonths: 1,
			minDate: 0,
			onSelect: function( selectedDate ) {
				let getDate = $(this).datepicker('getDate');
				let newDate = new Date(getDate.getTime());
				newDate.setDate(newDate.getDate() + 3);
				$( "#pre-CheckOut" ).datepicker( "setDate", newDate );
				$( "#pre-CheckOut" ).datepicker( "option", "minDate", selectedDate );
			}
		});
		$( "#pre-CheckOut" ).datepicker({
			//showOn: "both",
			//buttonImage: SITE_FILES+"images/img-calendar-gray.png",
			//buttonImageOnly: true,
			changeMonth: true,
			numberOfMonths: 1,
			onSelect: function( selectedDate ) {
				//$( "#CheckIn" ).datepicker( "option", "maxDate", selectedDate );
			}
		});

		// Map: Return to previous page button. Change body id to match map template's name.
		//$('body#map-category-sidebar #content').prepend('<a class="btn return-from-map" href="javascript:history.back()">« Back to previous page</a>');

		//Add active class to primary nav items
		// Main Nav Dropdown
		// $("a.scroll").click(function(){
		// 	$("a.scroll").each(function(){
		// 		$(this).removeClass("active");
		// 	});
		// 	$(this).addClass("active");	
		// });

		// Main Menu Remove Active State
		// $("#primary-nav li a").each(function(){
		// 	$(this).removeClass('active');	
		// }); 

		//Interactive map - show pin info when click
		$(".js-pin").click(function(){
			let idpin = $(this).attr("data-idpin");
			$(".each-location").css("display","none");	
			$(".js-pin").removeClass("active");
			$("#each-location"+idpin).fadeToggle();
			$(this).addClass("active");

		}); 
		
		//Show languages links
		$("#js-language-selector").click(function(){
			$("#languages-selector").css("display","flex");	
			$("#js-language-selector").css("display","none");
		}); 

		//Show venue item
		$(".js-view-more").click(function(){
			$(".list-item-content").removeClass("active");
			$(".close-list-item").removeClass("active");
			$(".js-view-more").removeClass("active");
			$(this).parent().siblings(".list-item-content").addClass("active");
			$(this).addClass("active");
			$(this).siblings(".close-list-item").addClass("active");
		});

		//hide venue item
		$(".close-list-item").click(function(){
			$(".list-item-content").removeClass("active");
			$(this).removeClass("active");
			$(this).siblings(".js-view-more").removeClass("active");
		});

	}); 

	$(window).on('load', function(){ 

		$.fn.zIndex = function(){}

		//Preloader
		$('#preloader').fadeOut('slow');

		let alink = document.querySelector('a[href="http://usc-lp.symphonyhotelmarketing.com"]');
		if (alink) {
		  alink.setAttribute('href', 'http://usc-lp.symphonyhotelmarketing.com/index-ori.php')
		}

		$("a[href='/privacy-policy']").attr("target", "_parent");
		$("a[href='https://www.google.com/maps/place/34.019248,-118.281159']").attr("href","https://www.google.com/maps/dir/USC+Hotel,+South+Figueroa+Street,+Los+Angeles,+CA//@34.0191296,-118.316271,13z/data=!4m9!4m8!1m5!1m1!1s0x80c2c76e3d691a75:0x85c543b7a2f521ab!2m2!1d-118.2812516!2d34.0190634!1m0!3e0")

        //Add 0 To slick Dots
        $(".top-reasons ul.slick-dots li button").each(function(){
           let dotsNumber = $(this).text();
            //console.log(dotsNumber);
            if($(dotsNumber).length < 2){
                $(this).html(0 + dotsNumber);
            }
        });

        //Add 0 To slick Dots
        $(".specials ul.slick-dots li button").each(function(){
           let dotsNumber = $(this).text();
            //console.log(dotsNumber);
            if($(dotsNumber).length < 2){
                $(this).html(0 + dotsNumber);
            }
        });

        //equalize();
        addAdaMapLink('light-bg dark','View list of ATTRACTIONS & ENTERTAINMENT');
		
	});

}());

if ('NodeList' in window && !NodeList.prototype.forEach) {
    console.info('polyfill for IE11');
    NodeList.prototype.forEach = function (callback, thisArg) {
        thisArg = thisArg || window;
        for (let i = 0; i < this.length; i++) {
            callback.call(thisArg, this[i], i, this);
        }
    };
}